import { useEffect, useState } from "react";
import {
  Button,
  OverlayTrigger,
  Spinner,
  Table,
  Toast,
  ToastContainer,
  Tooltip,
} from "react-bootstrap";
import { FaUserPlus } from "react-icons/fa";
import { RiFileHistoryLine } from "react-icons/ri";
import { TbBuildingMinus } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import adminApi from "../../../api/adminApi";
import adminCompanyCreditApi from "../../../api/adminCompanyCredit";
import adminUserCreditApi from "../../../api/adminUserCreditApi";
import companyApi from "../../../api/company";
import companyUserApi from "../../../api/companyUsers";

import Pagination from "../../../components/Pagination";
import CompanyCreditRequestModal from "../credits/CompanyCreditRequestModal";
import AddCompanyModal from "./AddCompanyModal";
import AddUserModal from "./AddUserModal";
import DeleteCompanyModal from "./DeleteCompanyModal";

const CreatedCompanies = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [country, setCountry] = useState("");
  const [location, setLocation] = useState("");
  const [modalType, setModalType] = useState(""); // "addCompany" or "addUser"
  const [selectedCompany, setSelectedCompany] = useState(null); // for addUser
  const [description, setDescription] = useState("");
  const [showCompanyToast, setCompanyShowToast] = useState(false);
  const [userInivitationToast, setUserInivitatonToast] = useState(false);
  const [inviteEmail, setInviteEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("Sender");
  const [showCreditRequestModal, setShowCreditRequestModal] = useState(false);
  const [requestedCredits, setRequestedCredits] = useState("");
  const [requestCPUnit, setRequestCPUnit] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const [companyCredits, setCompanyCredits] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [showAddCompanyModal, setShowAddCompanyModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);

  const [creditPiceUnit, setCreditPiceUnit] = useState(0);
  useEffect(() => {
    fetchCreditHistory();
  }, []);

  const fetchCreditHistory = () => {
    adminApi.getCurrentCredits().then((res) => {
      setCreditPiceUnit(res.data.creditPiceUnit);
      console.log(creditPiceUnit);
    });
  };
  const fetchCompanies = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.userEmail) return;

      const response = await companyApi.getCompaniesByEmail(
        user.userEmail,
        page,
        pageSize,
        sortedColumn,
        sortOrder,
      );
      const companiesData = response.data.content || [];
      setCompanies(companiesData);
      setTotalPages(response.data.totalPages || 0);

      const creditPromises = companiesData.map(async (company) => {
        try {
          const res = await adminCompanyCreditApi.getCompanyCreditsByCompany(
            company.companyName,
          );
          return { name: company.companyName, credits: res.data };
        } catch (error) {
          console.error(
            `Error fetching credits for ${company.companyName}:`,
            error,
          );
          setTotalPages(0);
          setCompanies([]);
          return { name: company.companyName, credits: null };
        }
      });

      const creditResults = await Promise.all(creditPromises);

      // Map results into an object for quick lookup
      const creditsMap = {};
      creditResults.forEach((item) => {
        creditsMap[item.name] = item.credits;
      });

      setCompanyCredits(creditsMap);
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, [page, pageSize, sortedColumn, sortOrder]);

  const getInitials = (name = "") => {
    return name
      .split(" ")
      .map((word) => word[0] + word[1])
      .join("")
      .toUpperCase();
  };

  const truncate = (text = "", length = 20) =>
    text.length > length ? text.substring(0, length) + "..." : text;

  const handleSubmitRequest = async () => {
    const companyData = {
      companyName,
      description,
      mobileNumber,
      adminUserName: user?.userName,
      adminEmail: user?.userEmail,
      country,
      location,
    };

    try {
      await companyApi.createCompany(companyData);
      await fetchCompanies();
      setCompanyShowToast(true);
      setCompanyName("");
      setMobileNumber("");
      setDescription("");
      setRequestCPUnit("");
      setCountry("");
      setLocation("");
      handleClose();
    } catch (error) {
      console.error("Error creating company:", error);
    }
  };

  const handleShowAddCompanyModal = () => {
    setShowAddCompanyModal(true);
  };

  const handleCloseAddCompanyModal = () => {
    setShowAddCompanyModal(false);
    setCompanyName("");
    setMobileNumber("");
    setDescription("");
    setCountry("");
    setLocation("");
  };

  const handleShowAddUserModal = (company) => {
    setSelectedCompany(company);
    setModalType("addUser");
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
    setModalType("");
    setSelectedCompany(null);
    setCompanyName("");
    setMobileNumber("");
    setDescription("");
    setInviteEmail("");
    setRequestCPUnit(creditPiceUnit);
    setSelectedRole(selectedRole);
  };

  const handleRequestForCredits = async (company) => {
    console.log(company);
    setSelectedCompany(company);
    setShowCreditRequestModal(true);
  };

  const handleSendRequestForCredits = async (requestData) => {
    try {
      const sendingCompanycreditsRequest = {
        userEmail: user?.userEmail,
        userName: user?.userName,
        companyName: selectedCompany?.companyName,
        companyId: selectedCompany?.id,
        credits: parseInt(requestedCredits, 10),
        mobileNumber: mobileNumber,
        frymeType: "BUSINESS",
      };
      const response = await adminUserCreditApi.requestUserCredits(
        sendingCompanycreditsRequest,
      );
      setShowCreditRequestModal(false);
      Swal.fire({
        title: "Request Submitted!",
        text: "Your request for credits has been sent to the admin. Please wait, the admin will assign credits for you.",
        icon: "success",
        confirmButtonText: "OK",
      });
      console.log("Credit request submitted:", requestData);

      setRequestedCredits(requestedCredits);
      setRequestCPUnit("");
      setMobileNumber("");

      console.log("Credit request submitted:", response.data);
    } catch (error) {
      console.error("Error submitting credit request:", error);

      Swal.fire({
        title: "Error!",
        text: "Failed to submit your credit request. Please try again.",
        icon: "error",
        confirmButtonText: "Close",
      });
    }
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1)); // Ensure selectedPage is within range
    setPage(selectedPage);
    localStorage.setItem("createdCompanies", selectedPage); // Store the page number in localStorage
  };

  const handleSort = (column) => {
    if (sortedColumn === column) {
      // Toggle sort order if the same column is clicked
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(column);
      setSortOrder("asc");
    }
  };
  const handleInviteUser = (success) => {
    if (success) {
      fetchCompanies();
    }
  };
  // const handleDeleteCompany = async (company) => {
  //   const result = await Swal.fire({
  //     title: "Are you sure?",
  //     text: `Do you want to delete the company "${company.companyName}"?`,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     cancelButtonColor: "#3085d6",
  //     confirmButtonText: "Yes, delete it!",
  //   });

  //   console.log(company.id, user?.userEmail);
  //   if (result.isConfirmed) {
  //     try {
  //       console.log("Deleting:", company.id, user?.userEmail);

  //       await companyApi.deleteCompanyByAdmin(
  //         company.id, // ✅ correct
  //         user?.userEmail, // ✅ correct
  //       );

  //       Swal.fire(
  //         "Deleted!",
  //         `You are deleted from the company "${company.companyName}".`,
  //         "success",
  //       );

  //       fetchCompanies();
  //     } catch (error) {
  //       console.error("Error deleting company:", error);
  //       Swal.fire(
  //         "Error!",
  //         "There was an issue deleting the company.",
  //         "error",
  //       );
  //     }
  //   }
  // };

  const handleDeleteCompany = (company) => {
    setCompanyToDelete(company);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async ({ reason, newAdmin }) => {
    console.log(companyToDelete.id, companyToDelete.companyName, newAdmin);
    try {
      setShowDeleteModal(false);

      if (newAdmin) {
        await companyUserApi.promoteUserToAdmin(companyToDelete.id, newAdmin);
      }

      // Delete company
      await companyApi.deleteCompanyByAdmin(
        companyToDelete.id,
        user?.userEmail,
      );

      Swal.fire(
        "Deleted!",
        `Company "${companyToDelete.companyName}" has been deleted.`,
        "success",
      );

      fetchCompanies();
    } catch (error) {
      console.error("Error deleting company:", error);
      Swal.fire("Error!", "There was an issue deleting the company.", "error");
    }
  };
  const handleNavigate = (company) => {
    const encodedName = encodeURIComponent(company.companyName);
    const tabValue = "created";

    navigate(
      `/dashboard/creditPassBook/my-companies/${encodedName}/transactionLedger`,
      { state: { tab: tabValue } },
    );
  };

  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {loading ? (
        <Spinner animation="border" />
      ) : companies.length > 0 ? (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">
              <strong>The companies which are created by yourself</strong>
            </h5>
            {/* <Button onClick={handleShowAddCompanyModal}>Add Company</Button> */}
          </div>
          <div style={{ overflowX: "auto", width: "100%" }}>
            <Table
              striped
              bordered
              hover
              responsive
              style={{ minWidth: "1100px", whiteSpace: "nowrap" }}
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Company Name</th>
                  <th>Description</th>
                  <th>Balance Credits</th>
                  <th>Used Credits</th>
                  <th>CPU</th>
                  <th>Credit Request</th>
                  <th>Transactions</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {companies.map((company, index) => {
                  const credits = companyCredits[company.companyName]; // ✅ get correct credits
                  return (
                    <tr key={company.id}>
                      <td>{index + 1}</td>
                      <td>
                        {company.companyName} -{" "}
                        {getInitials(company.adminUserName)}
                      </td>
                      <td>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-desc-${company.id}`}>
                              {company.description}
                            </Tooltip>
                          }
                        >
                          <span style={{ cursor: "pointer" }}>
                            {truncate(company.description)}
                          </span>
                        </OverlayTrigger>
                      </td>

                      <td>{credits ? credits.balanceCredit : "Loading..."}</td>
                      <td>{credits ? credits.usedCredit : "Loading..."}</td>
                      <td>
                        {credits ? credits.creditPriceUnit : "Loading..."}
                      </td>

                      <td>
                        <Button
                          onClick={() => handleRequestForCredits(company)}
                        >
                          Request for Credits
                        </Button>
                      </td>

                      <td>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-add-${company.id}`}>
                              Ledger of Transactions
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="link"
                            onClick={() => {
                              handleNavigate(company); // Ensure handleNavigate is passing the correct parameters
                            }}
                          >
                            <RiFileHistoryLine size={30} />
                          </Button>
                        </OverlayTrigger>
                      </td>

                      <td>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-add-${company.id}`}>
                              Add Users
                            </Tooltip>
                          }
                        >
                          <Button
                            size="sm"
                            variant="success"
                            className="me-1 mb-1"
                            onClick={() => handleShowAddUserModal(company)}
                          >
                            <FaUserPlus />
                          </Button>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id={`tooltip-delete-company-${company.id}`}
                            >
                              Delete Company
                            </Tooltip>
                          }
                        >
                          <Button
                            size="sm"
                            variant="danger"
                            className="me-1 mb-1"
                            onClick={() => handleDeleteCompany(company)}
                          >
                            <TbBuildingMinus />
                          </Button>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          {companies.length > 0 && totalPages > 0 && (
            <div style={{ marginTop: "auto" }}>
              <Pagination
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                handlePageSizeChange={handlePageSizeChange}
                handlePageClick={handlePageClick}
              />
            </div>
          )}
        </>
      ) : (
        <p>No companies found.</p>
      )}

      <CompanyCreditRequestModal
        show={showCreditRequestModal}
        onClose={() => setShowCreditRequestModal(false)}
        companyName={selectedCompany?.companyName}
        companyId={selectedCompany?.id}
        userEmail={user?.userEmail}
        onSend={handleSendRequestForCredits}
      />

      <ToastContainer position="top-end" className="p-3">
        {showCompanyToast && (
          <Toast
            onClose={() => setCompanyShowToast(false)}
            show
            delay={3000}
            autohide
            bg="success"
          >
            <Toast.Header>
              <strong className="me-auto">Company Added</strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              Company added successfully.
            </Toast.Body>
          </Toast>
        )}

        {userInivitationToast && (
          <Toast
            onClose={() => setUserInivitatonToast(false)}
            show
            delay={3000}
            autohide
            bg="success"
          >
            <Toast.Header>
              <strong className="me-auto">User Invited</strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              User invitation sent successfully.
            </Toast.Body>
          </Toast>
        )}
      </ToastContainer>
      <AddUserModal
        show={showModal}
        onClose={handleClose}
        selectedCompany={selectedCompany}
        onInviteUser={handleInviteUser}
        loading={loading}
      />

      <AddCompanyModal
        show={showAddCompanyModal}
        onClose={handleCloseAddCompanyModal}
        companyName={companyName}
        setCompanyName={setCompanyName}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
        setCountry={setCountry}
        country={country}
        location={location}
        setLocation={setLocation}
        description={description}
        setDescription={setDescription}
        handleSubmitRequest={handleSubmitRequest}
        loading={loading}
      />
      <DeleteCompanyModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        company={companyToDelete}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
};

export default CreatedCompanies;
